import { RewardWallet } from './RewardWallet';
import { TransactionsHistory } from './TransactionsHistory';
import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';

const getDateWithoutTimezone = (date: string) => {
    const parts = date.split('T');
    if (parts.length === 2) {
        const dateString = parts[0];
        const timeString = parts[1]?.split('-')[0];
        const dateWithoutTimezone = `${dateString}T${timeString}`;
        const readyDate = new Date(dateWithoutTimezone);
        return readyDate;
    }
    return date;
};

export class UserRewards {
    maximumPointsLimit: number;
    pointsCount: number;
    pointsUntilReward: number;
    totalRewardAmount: number;
    pointsRewardAmount: number;
    earliestPointsToExpireDate: string;
    rewardsCounter: number;
    expirationDate: string;
    rewardValue: number;
    rewardsWallets: Array<RewardWallet>;

    public static Make(history: TransactionsHistory): UserRewards {
        const {
            maximumPointsLimit,
            pointsCount,
            pointsUntilReward,
            totalRewardAmount,
            pointsRewardAmount,
            earliestPointsToExpireDate,
            rewardsWallets,
        } = history;

        let formattedDate = '';
        let totalRewardValue = 0;

        if (rewardsWallets.length > 0) {
            const parsedDate = getDateWithoutTimezone(rewardsWallets[0].expirationDate.toString());
            formattedDate = format(new Date(parsedDate), 'MM/dd/yyyy', {
                locale: enUS,
            });
            totalRewardValue = rewardsWallets[0].rewardValue;
        }

        const userRewards: UserRewards = {
            maximumPointsLimit,
            pointsCount: pointsCount ?? 0,
            pointsUntilReward,
            totalRewardAmount,
            pointsRewardAmount,
            earliestPointsToExpireDate,
            rewardsWallets,
            rewardsCounter: rewardsWallets.length,
            rewardValue: totalRewardValue,
            expirationDate: formattedDate,
        };

        return userRewards;
    }
}
